import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-36" data-mp="22elmevptxplz">
      <div className="max-w-5xl mx-auto" data-id="element-37" data-mp="22dagoqctq7s8">
        <div className="text-center mb-16" data-id="element-38" data-mp="1ydrulr99nqnt">
          <p className="text-gold-dark font-bold tracking-[0.2em] uppercase mb-2 text-sm" data-id="element-39" data-mp="1ybx9ocxzvyjq">
            And That’s Not All — Included at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy" data-id="element-40" data-mp="15qnmhdevmw7t">
            5 Premium Bonus Guides
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-41" data-mp="1jilnf0yfplsw">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-gold/40 rounded-2xl p-8 relative shadow-sm flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-42" data-mp="r0gfpuy8f1my" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-navy text-gold-light px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm tracking-wider" data-id="element-43" data-mp="2jixs8swx771d">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-aqua-light rounded-full flex items-center justify-center text-aqua-dark mb-4" data-id="element-44" data-mp="1quim6vvrnz26">
                <GiftIcon size={24} data-id="element-45" data-mp="1vsk3pcdjnqbj" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-24 text-navy" data-id="element-46" data-mp="20r553f4j8g1k">
                {bonus.title}
              </h3>
              <p className="text-sm text-aqua-dark font-medium mb-4 leading-snug" data-id="element-47" data-mp="25s2lbm5zf00f">
                {bonus.headline}
              </p>
              <p className="text-graphite text-sm leading-relaxed mb-5" data-id="element-48" data-mp="3h5my5duqu3si">{bonus.intro}</p>

              <div className="grid sm:grid-cols-2 gap-5 mb-5" data-id="element-49" data-mp="3h7hlszxega0a">
                {bonus.groups.map(group => <div key={group.title} data-id="element-50" data-mp="1c4apqomc2tak">
                    <h4 className="text-xs font-bold text-navy uppercase tracking-wider mb-2" data-id="element-51" data-mp="1c3ivbh4h31lv">
                      {group.title}
                    </h4>
                    <ul className="space-y-1.5" data-id="element-52" data-mp="1m2i4r1x2b19x">
                      {group.items.map(item => <li key={item} className="text-graphite text-sm leading-relaxed flex items-start gap-2" data-id="element-53" data-mp="ycnveubybuuf">
                          <span className="text-aqua-dark mt-1.5 h-1 w-1 rounded-full bg-aqua-dark shrink-0" data-id="element-54" data-mp="1757nfbxqn16a" />
                          <span data-id="element-55" data-mp="12er81macx5ha">{item}</span>
                        </li>)}
                    </ul>
                  </div>)}
              </div>

              <div className="mt-auto pt-4 border-t border-pearl-dark flex flex-wrap items-center gap-3" data-id="element-56" data-mp="anbcv3uqiafg">
                <span className="text-gold-dark font-bold text-xs uppercase tracking-[0.2em]" data-id="element-57" data-mp="jee5oz2zdom">
                  Included Free
                </span>
                <p className="text-navy text-sm italic font-medium" data-id="element-58" data-mp="5awfwf8xhian">{bonus.benefit}</p>
              </div>
            </motion.article>)}
        </div>

        <CountdownTimer data-id="element-59" data-mp="3rp652qkomuch" />
      </div>
    </section>;
}